import EntityTypeEnum from 'common/enums/entityTypeEnum'
import ServerPageInterface from 'src/shared/types/server-page-interface'
import { CarouselItemInterface } from 'src/shared/entities/carousel/carousel.schema'
import { generateHtmlAttrId } from 'src/shared/entities/utils/generate-base-entity'
import { migrateCommand } from 'tools/commands/migrate/utils/migrateCommand'

const addHtmlAttrIdToSubItem = (
  entity: CarouselItemInterface,
): CarouselItemInterface => {
  if (!entity.htmlAttrId) {
    entity.htmlAttrId = generateHtmlAttrId(EntityTypeEnum.CarouselItem)
  }

  return entity
}

export default (page: ServerPageInterface) =>
  migrateCommand({
    page,
    structureType: EntityTypeEnum.CarouselItem,
    migrateFunction: addHtmlAttrIdToSubItem,
  })
